import { useState } from 'react';
import useSWR from 'swr';

import { useCartContext } from '@zooplus/cart-provider';

export function useCart() {
  return useSWR(
    '/semiprotected/api/checkout/state-api/v2/cart',
    async (...args): Promise<string> => {
      const response = await fetch(...args);

      return await response.json();
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
      dedupingInterval: 5000,
      revalidateOnFocus: false,
    },
  );
}

export function useMembershipInCart() {
  const { cart } = useCartContext();

  return cart?.articles?.some(
    // @ts-expect-error Not appear in current definition of CartArticle
    (article) => article.loyaltyManagementArticle || article.type === 'LoyaltyManagement',
  );
}

export function useCartArticlesSubtotal() {
  const { cart } = useCartContext();

  // @ts-expect-error Not appear in current definition of Cart
  if (typeof cart?.sumOfStandardArticlesSubTotal !== 'string') {
    return undefined;
  }

  // @ts-expect-error Not appear in current definition of Cart
  return Math.abs(parseFloat(cart.sumOfStandardArticlesSubTotal));
}

export function useAddMembershipToCart(
  initialStateCart: boolean = false,
  onAddToCartSuccess: () => void = () => {},
  onRemoveFromCartSuccess: () => void = () => {},
) {
  const [isMembershipAddedToCart, setIsMembershipAddedToCart] = useState(initialStateCart);

  const addMembershipToCart = async (articleId?: number) => {
    if (articleId) {
      try {
        const response = await fetch(
          `/semiprotected/api/checkout/state-api/v2/add-loyalty-management-article/${articleId}`,
          {
            method: 'PATCH',
          },
        );
        if (response.status === 200) {
          setIsMembershipAddedToCart(true);
          onAddToCartSuccess();
          return;
        }
      } catch (error: unknown) {
        if (error instanceof Error) {
          console.log(error.message, error);
        }
        throw error;
      }
    }
    throw new Error('No articleId provided');
  };

  const removeMembershipFromCart = async () => {
    await fetch('/semiprotected/api/checkout/state-api/v2/remove-loyalty-management-article', {
      method: 'DELETE',
    })
      .then((response) => {
        if (response.status === 200) {
          setIsMembershipAddedToCart(false);
          onRemoveFromCartSuccess();
        }
      })
      .catch((error) => {
        console.log(error.message, error);
      });
  };

  return {
    isMembershipAddedToCart,
    addMembershipToCart,
    removeMembershipFromCart,
  };
}
